import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { crPoliciesInitialState } from '../state';
import { restApiFormData } from '../../api/axios';
import { API_ENDPOINTS } from '../../api/constants';
import toast from 'react-hot-toast';

export const getCRPolicies = createAsyncThunk('getCRPolicies', (data = {}, { rejectWithValue }) =>
    restApiFormData
        .post(`${API_ENDPOINTS.LIST_CHANGE_REQUEST_POLICIES}?${data.query.toString()}`)
        .then((res) => {
            if (res?.data?.status !== 'SUCCESS') {
                return rejectWithValue(res?.data);
            }
            return res.data;
        })
        .catch((error) => {
            if (error?.response?.status === 400) toast.error(error?.response?.data?.message);
            else toast.error(error.message);
            return rejectWithValue(error);
        }),
);

export const preCreateChangeRequestPolicy = createAsyncThunk(
    'preCreateChangeRequestPolicy',
    (data = {}, { rejectWithValue }) =>
        restApiFormData
            .post(API_ENDPOINTS.PRE_CREATE_CHANGE_REQUEST_POLICY, data)
            .then((res) => {
                if (res.status !== 200 || res?.data?.status === 'ERROR') {
                    return rejectWithValue(res?.data);
                }

                return res.data;
            })
            .catch((error) => {
                if (error?.response?.status === 400) toast.error(error?.response?.data?.message);
                else toast.error(error.message);
                return rejectWithValue(error);
            }),
);

export const createChangeRequestPolicy = createAsyncThunk(
    'createChangeRequestPolicy',
    (data = {}, { rejectWithValue }) =>
        restApiFormData
            .post(API_ENDPOINTS.CREATE_CHANGE_REQUEST_POLICY, data)
            .then((res) => {
                if (res?.data?.status !== 'SUCCESS') {
                    return rejectWithValue(res?.data);
                }
                return res.data;
            })
            .catch((error) => {
                if (error?.response?.status === 400) toast.error(error?.response?.data?.message);
                else toast.error(error.message);
                return rejectWithValue(error);
            }),
);

export const preModifyChangeRequestPolicy = createAsyncThunk(
    'preModifyChangeRequestPolicy',
    (data = {}, { rejectWithValue }) =>
        restApiFormData
            .post(API_ENDPOINTS.PRE_MODIFY_CHANGE_REQUEST_POLICY, data)
            .then((res) => {
                if (res.status !== 200) {
                    return rejectWithValue(res?.data);
                }

                return res.data;
            })
            .catch((error) => {
                if (error?.response?.status === 400) toast.error(error?.response?.data?.message);
                else toast.error(error.message);
                return rejectWithValue(error);
            }),
);

export const modifyChangeRequestPolicy = createAsyncThunk(
    'modifyChangeRequestPolicy',
    (data = {}, { rejectWithValue }) =>
        restApiFormData
            .post(API_ENDPOINTS.MODIFY_CHANGE_REQUEST_POLICY, data)
            .then((res) => {
                if (res?.data?.status !== 'SUCCESS') {
                    return rejectWithValue(res?.data);
                }
                return res.data;
            })
            .catch((error) => {
                if (error?.response?.status === 400) toast.error(error?.response?.data?.message);
                else toast.error(error.message);
                return rejectWithValue(error);
            }),
);

export const searchChangeCRPolicesAction = createAsyncThunk(
    'searchChangeCRPolicesAction',
    (data = {}, { rejectWithValue }) =>
        restApiFormData
            .post(API_ENDPOINTS.SEARCH_CHANGE_REQUEST_POLICIES_ACTION, data)
            .then((res) => {
                if (res?.data?.status !== 'SUCCESS') {
                    return rejectWithValue(res?.data);
                }
                return res.data;
            })
            .catch((error) => {
                if (error?.response?.status === 400) toast.error(error?.response?.data?.message);
                else toast.error(error.message);
                return rejectWithValue(error);
            }),
);

export const getPositionsMappedToChangeRequestPolicy = createAsyncThunk(
    'getPositionsMappedToChangeRequestPolicy',
    (data = {}, { rejectWithValue }) =>
        restApiFormData
            .post(API_ENDPOINTS.GET_POSITIONS_MAPPED_TO_CHANGE_REQUEST_POLICY, data)
            .then((res) => {
                if (res?.data?.status !== 'SUCCESS') {
                    return rejectWithValue(res?.data);
                }
                return res.data;
            })
            .catch((error) => {
                if (error?.response?.status === 400) toast.error(error?.response?.data?.message);
                else toast.error(error.message);
                return rejectWithValue(error);
            }),
);

export const deleteChangeRequestPolicy = createAsyncThunk(
    'deleteChangeRequestPolicy',
    (data = {}, { rejectWithValue }) =>
        restApiFormData
            .post(API_ENDPOINTS.DELETE_CHANGE_REQUEST_POLICY, data)
            .then((res) => {
                return res?.data;
            })
            .catch((error) => {
                if (error?.response?.status === 400) toast.error(error?.response?.data?.message);
                else toast.error(error.message);
                return rejectWithValue(error);
            }),
);

export const bulkUpdatePositionChangeRequestPolicyMappings = createAsyncThunk(
    'bulkUpdatePositionChangeRequestPolicyMappings',
    (data = {}, { rejectWithValue }) =>
        restApiFormData
            .post(API_ENDPOINTS.UPDATE_POSITIONS_MAPPED_TO_CHANGE_REQUEST_POLICY, data)
            .then((res) => {
                return res?.data;
            })
            .catch((error) => {
                if (error?.response?.status === 400) toast.error(error?.response?.data?.message);
                else toast.error(error.message);
                return rejectWithValue(error);
            }),
);

export const displayChangeRequestPolicy = createAsyncThunk(
    'displayChangeRequestPolicy',
    (data = {}, { rejectWithValue }) =>
        restApiFormData
            .post(API_ENDPOINTS.DISPLAY_CHANGE_REQUEST_POLICY, data)
            .then((res) => {
                if (res.status !== 200) {
                    return rejectWithValue(res?.data);
                }
                return res.data;
            })
            .catch((error) => {
                if (error?.response?.status === 400) toast.error(error?.response?.data?.message);
                else toast.error(error.message);
                return rejectWithValue(error);
            }),
);

export const getPositionList = createAsyncThunk('getPositionList', (data = {}, { rejectWithValue }) =>
    restApiFormData
        .post(`${API_ENDPOINTS.LIST_POSITIONS}?${data.query.toString()}`)
        .then((res) => {
            if (res.status !== 200) {
                return rejectWithValue(res?.data);
            }
            return res.data;
        })
        .catch((error) => {
            if (error?.response?.status === 400) toast.error(error?.response?.data?.message);
            else toast.error(error.message);
            return rejectWithValue(error);
        }),
);

const listCRPolicies = createSlice({
    name: 'crPolicies',
    initialState: crPoliciesInitialState,
    extraReducers: {
        [getCRPolicies.pending]: (state) => {
            state.isLoading = true;
        },
        [getCRPolicies.rejected]: (state) => {
            state.hasErrored = true;
        },
        [getCRPolicies.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.createCRPolicy = {};
            state.crPolicies = action.payload.changeRequestPolicies;
            state.deleteCRPolicy = {};
            state.changeRequestPolicyCount = action.payload.changeRequestPolicyCount;
        },
        [preCreateChangeRequestPolicy.fulfilled]: (state, action) => {
            state.availableStatuses = action.payload.availableStatuses;
            state.majorApprovers = action.payload.majorApprovers;
            state.minorApprovers = action.payload.minorApprovers;
            state.clientApprovers = action.payload.clientApprovers ?? [];
        },
        [createChangeRequestPolicy.fulfilled]: (state, action) => {
            state.createCRPolicy = action.payload;
        },
        [modifyChangeRequestPolicy.fulfilled]: (state, action) => {
            state.createCRPolicy = action.payload;
        },
        [deleteChangeRequestPolicy.fulfilled]: (state, action) => {
            state.deleteCRPolicy = action.payload;
        },
        [searchChangeCRPolicesAction.pending]: (state) => {
            state.isLoading = true;
        },
        [searchChangeCRPolicesAction.rejected]: (state) => {
            state.hasErrored = true;
        },
        [searchChangeCRPolicesAction.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.crPolicies = action.payload.changeRequestPolicies;
        },
        [getPositionsMappedToChangeRequestPolicy.pending]: (state) => {
            state.positionsMapped.isLoading = true;
        },
        [getPositionsMappedToChangeRequestPolicy.rejected]: (state) => {
            state.positionsMapped.hasErrored = true;
        },
        [getPositionsMappedToChangeRequestPolicy.fulfilled]: (state, action) => {
            state.positionsMapped.isLoading = false;
            state.positionsMapped.mapped = action.payload.mappedPositions;
            state.positionsMapped.count = action.payload.totalCount;
            state.isLoading = false;
        },
        [getPositionList.pending]: (state) => {
            state.isLoading = true;
        },
        [getPositionList.rejected]: (state) => {
            state.hasErrored = true;
        },
        [getPositionList.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.listPositions = action.payload.positionInstanceList;
            state.changeRequestPolicyCount = action.payload.positionInstanceCount;
        },
        [displayChangeRequestPolicy.pending]: (state) => {
            state.viewPolicy.isLoading = true;
        },
        [displayChangeRequestPolicy.rejected]: (state) => {
            state.viewPolicy.hasErrored = true;
        },
        [displayChangeRequestPolicy.fulfilled]: (state, action) => {
            state.viewPolicy.isLoading = false;
            state.viewPolicy.positionChangeRequestPolicy = action.payload.positionChangeRequestPolicy;
            state.viewPolicy.commentsMap = action.payload.commentsMap;
        },
        [preModifyChangeRequestPolicy.pending]: (state) => {
            state.modifyPolicy.isLoading = true;
        },
        [preModifyChangeRequestPolicy.fulfilled]: (state, action) => {
            state.modifyPolicy.isLoading = false;
            state.modifyPolicy.positionChangeRequestPolicy = action.payload.changeRequestPolicy;
            state.modifyPolicy.approvers = action.payload.changeRequestPolicy?.approvers;
            state.availableStatuses = action.payload.availableStatuses;
            state.majorApprovers = action.payload.majorApprovers;
            state.minorApprovers = action.payload.minorApprovers;
            state.clientApprovers = action.payload.clientApprovers ?? [];
        },
    },
});

export default listCRPolicies.reducer;
